import React from 'react'

import { Box, Heading2, Paragraph, TextAlign } from '@gousto-internal/citrus-react'

import { welcomeSectionTexts } from 'routes/Home/PriceComparisonTable/constants'

export const WelcomeSection = () => (
  <Box maxWidth={['18.5rem', '100%', '25rem']} data-testid="WelcomeSectionContainer">
    <Heading2 textAlign={[TextAlign.Center, null, TextAlign.Left]}>
      {welcomeSectionTexts.heading}
    </Heading2>
    <Box paddingV={4} paddingBottom={[0, 0, 6, 6]}>
      <Paragraph fontWeight={400} size={3} textAlign={[TextAlign.Center, null, TextAlign.Left]}>
        {welcomeSectionTexts.subheading}
      </Paragraph>
    </Box>
  </Box>
)
